import { useState } from "react";
import { CheckCircle2, LifeBuoy, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { micDiagnostics } from "@/lib/micGate";

// One tap sends browser + permission details to the admin Contact Messages inbox
export const MicHelpButton = ({ state, className = "" }) => {
  const { user, guest } = useAuth();
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  if (!user && !guest) return null;
  const send = async () => {
    setBusy(true);
    try {
      const g = !localStorage.getItem("lexv_token") && guest?.token;
      await api.post("/mic-help", await micDiagnostics(state), g ? { headers: { Authorization: `Bearer ${g}` } } : undefined);
      setSent(true);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  if (sent) return <p data-testid="mic-help-sent" className={`flex items-center gap-1.5 text-xs font-semibold text-emerald-700 ${className}`}><CheckCircle2 className="h-4 w-4" />Sent. Our team will reply to {user?.email || "your email"}.</p>;
  return (
    <button data-testid="mic-help-btn" onClick={send} disabled={busy} className={`inline-flex items-center gap-1.5 text-xs font-semibold text-slate-500 underline-offset-2 transition-colors hover:text-indigo-600 hover:underline disabled:opacity-50 ${className}`}>
      {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <LifeBuoy className="h-3.5 w-3.5" />}My mic won't work — send my details to support
    </button>
  );
};
